// components/layout/Navbar.tsx
import React, { useState, useEffect } from 'react';
import { Navbar as BsNavbar, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import UserDropdown from './UserDropdown';
import { User } from '../../types/knowledge-base.ts';
// Import the original logos
import logo from '../../assets/of-logo.png'; // Original logo for desktop
import logoSmall from '../../assets/of-logo-small.png'; // Small logo for mobile
import '../../../scss/navbar.scss';

interface NavbarProps {
    user: User;
    onShowProfile: () => void;
    onPasswordReset: () => void;
    onLogout: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ user, onShowProfile, onLogout }) => {
    useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Listen for window resize to switch logos
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Get first name only for mobile view
    const getFirstName = () => {
        if (!user.fullName) return '';
        return user.fullName.split(' ')[0]; // Extract first name
    };

    return (
        <BsNavbar bg="white" expand="lg" className="shadow-sm navbar-fixed">
            <Container fluid className="px-3 d-flex justify-content-between align-items-center">
                <BsNavbar.Brand
                    href="/"
                    className="p-0"
                >
                    <img
                        src={isMobile ? logoSmall : logo}
                        style={{
                            height: isMobile ? '50px' : '70px', // Increased mobile logo size
                            width: 'auto'
                        }}
                        className="d-inline-block align-top"
                        alt="Logo"
                    />
                </BsNavbar.Brand>

                {/* Different layout for mobile */}
                {isMobile ? (
                    <div className="user-display">
                        <span className="user-name">Hi {getFirstName()}</span>
                        <UserDropdown
                            user={user}
                            onShowProfile={onShowProfile}
                            onLogout={onLogout}
                            isMobile={true}
                        />
                    </div>
                ) : (
                    <div className="d-flex align-items-center">
                        <UserDropdown
                            user={user}
                            onShowProfile={onShowProfile}
                            onLogout={onLogout}
                            isMobile={false}
                        />
                    </div>
                )}
            </Container>
        </BsNavbar>
    );
};

export default Navbar;